import throttle from "./_throttle";

export default function ManageGoToTop() {

	let previousScrollPosition = 0;
	const goToTop = document.querySelector( '.go-to-top' );

	const isScrollingDown = () => {
		let goingDown = false;
		let scrollPosition = window.scrollY;
		if ( scrollPosition > previousScrollPosition ) {
			goingDown = true;
		}
		previousScrollPosition = scrollPosition;
		return goingDown;
	};

	const isAfterViewport = () => {
		return ( window.scrollY > window.innerHeight );
	};

	const isAroundFooter = () => {		
		const footerTop = document.getElementById( 'main-footer' ).offsetTop - ( document.getElementById( 'main-footer' ).offsetHeight * 2 );
		return window.scrollY >= footerTop;
	}

	const handleScroll = () => {
		if ( !isScrollingDown() ) {
			if ( isAfterViewport() ) {
				goToTop.removeAttribute( 'hidden' );
			} else {
				goToTop.setAttribute( 'hidden', '' );
			}
		} else {
			if ( isAroundFooter() ) {
				goToTop.removeAttribute( 'hidden' );
				
			} else {
				goToTop.setAttribute( 'hidden', '' );
			}
		}
	};

	const scrollThrottle = throttle( handleScroll, 100 );
	window.addEventListener( "scroll", scrollThrottle );

}